import { Loader } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import styles from './DropdownPreloader.module.scss';

export const DropdownPreloader = observer(function DropdownPreloader() {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <p className={styles.text}>{t('common:pleaseWait')}</p>
      <Loader />
    </div>
  );
});
